import { useMemo } from "react";
import useRejectLineItemsState, {
  RejectLineItemsKey,
} from "./use-reject-line-items-state-context";

type UseLineItemSectionSummaryParams = {
  state: RejectLineItemsKey;
};

/**
 * For a given section of line items, give how many have been selected, and how many can be selected
 */
export default function useRejectLineItemsQuantitiesSummary({
  state: section,
}: UseLineItemSectionSummaryParams) {
  const { lineItemsState } = useRejectLineItemsState();

  return useMemo(() => {
    const result = Object.keys(lineItemsState).reduce(
      (acc, next) => {
        const lineItem = lineItemsState[next];
        const quantity = lineItem[section].selectedQuantity;
        const maxQuantity = lineItem[section].maxQuantity;
        acc.selected += quantity;
        acc.max += maxQuantity;
        return acc;
      },
      { max: 0, selected: 0 },
    );
    return result;
  }, [lineItemsState, section]);
}
